import { render, staticRenderFns } from "./SMClassEdit.vue?vue&type=template&id=0e28496c"
import script from "./SMClassEdit.vue?vue&type=script&lang=js"
export * from "./SMClassEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports